<ng-container>
    @if(isPageRestrictionLoaded){
    <div class="ppl-container-body" style="margin-top: -10px">
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="action add-btn">
                    <ppl-button label="Add New Application Config" icon="fa fa-plus" [customClass]="'primary-button'"
                        [iconPosition]="'left'" (click)="onAddConfig()"></ppl-button>
                </div>
                <div class="w-100">
                    <ppl-config-filter (searchEvent)="onSearch($event)" [filterFields]="fields"
                        [billingPageName]="'claims'"></ppl-config-filter>
                </div>

                <div class="table-style">
                    @if(configList.length > 0) {
                        <ppl-list-table [customDataLoaded]="true" [disableSearch]="true"
                        [showCustomSearch]="false" [cols]="cols" [enableActions]="false" [data]="configList"
                        (rowDetailEvent)="rowClicked($event)" [disableSelection]="true" [gridTitle]="false"
                        [pagination]="true" [loadPage]="true" (onPageLoad)="onPageLoad($event)" [from]="'billing'">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
                <!-- <div class="table-style">
                    <ppl-list-table [pageConfig]="programName" [sharedDataKey]="sharedDataKey"
                        (rowDetailEvent)="rowClicked($event)" [loadPage]="lazyLoad" [disableSelection]="true"
                        [columnsToBeHidden]="columnsToBeHidden" [actionsToBeHidden]="actionsToBeHidden"
                        [jsonList]="'list_config'" [from]="'billing'" rowDataAccessibilityKey="processCodeDetailId">
                    </ppl-list-table>
                </div> -->
            </div>
        </div>
    </div>
    }

</ng-container>